import { render, staticRenderFns } from "./ConfigRule.vue?vue&type=template&id=add7b5c4&scoped=true&"
import script from "./ConfigRule.vue?vue&type=script&lang=js&"
export * from "./ConfigRule.vue?vue&type=script&lang=js&"
import style0 from "./ConfigRule.vue?vue&type=style&index=0&id=add7b5c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add7b5c4",
  null
  
)

export default component.exports